import React, { useRef } from 'react';
import ReactQuill from 'react-quill';

interface QuillEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  modules?: any;
  formats?: string[];
  style?: React.CSSProperties;
}

// Suppress findDOMNode warning (react-quill issue)
if (typeof window !== 'undefined') {
  const originalConsoleError = console.error;
  console.error = (...args: any[]) => {
    // Suppress specific warnings from react-quill and Material-UI
    if (typeof args[0] === 'string' && (
      args[0].includes('findDOMNode') ||
      args[0].includes('@import') ||
      args[0].includes('unique "key" prop')
    )) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
}

/**
 * QuillEditor wrapper component that suppresses the findDOMNode deprecation warning
 * from react-quill when used with React.StrictMode.
 * 
 * This is a temporary solution until react-quill updates to use refs instead of findDOMNode.
 */
const QuillEditor: React.FC<QuillEditorProps> = ({ 
  value, 
  onChange, 
  placeholder,
  modules,
  formats,
  style
}) => {
  const quillRef = useRef<ReactQuill>(null);

  return (
    <ReactQuill
      ref={quillRef}
      theme="snow"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      modules={modules}
      formats={formats}
      style={style}
    />
  );
};

export default QuillEditor;
